(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $ = jQuery;
var Frontend = /*#__PURE__*/function () {
  function Frontend() {
    _classCallCheck(this, Frontend);
    this.isCart = $(document.body).hasClass('woocommerce-cart');
    this.isCheckout = $(document.body).hasClass('woocommerce-checkout');
    this.forms = {
      cart: {
        form: $('#csygc-redeem-form'),
        number: $('#csygc-redeem-gift-card-container #csygc-redeem-gift-card-number'),
        security_code: $('#csygc-redeem-gift-card-container #csygc-redeem-gift-card-security'),
        number_submit: $('#csygc-redeem-button'),
        value: $('#csygc-gift-card-value-container #csygc-value-gift-card-value'),
        value_submit: $('#csygc-value-button')
      },
      product: {
        form: $('.csygc-recipient-wrap'),
        gift: $('#csygc-recipient-gift'),
        giftAdded: $('.csygc-recipient-gift-added'),
        fields: $('.recipient-field')
      }
    };
    this.resetFormElements();
    this.setupEvents();
    this.setupEditMessageModal();
    $(document.body).on('wc_fragments_refreshed updated_checkout', this.setupEditMessageModal.bind(this));
  }
  return _createClass(Frontend, [{
    key: "resetFormElements",
    value: function resetFormElements() {
      this.forms = {
        cart: {
          form: $('#csygc-redeem-form'),
          number: $('#csygc-redeem-gift-card-container #csygc-redeem-gift-card-number'),
          security_code: $('#csygc-redeem-gift-card-container #csygc-redeem-gift-card-security'),
          number_submit: $('#csygc-redeem-button'),
          value: $('#csygc-gift-card-value-container #csygc-value-gift-card-value'),
          value_submit: $('#csygc-value-button')
        },
        product: {
          form: $('.csygc-recipient-wrap'),
          gift: $('#csygc-recipient-gift'),
          fields: $('.recipient-field')
        }
      };
    }
  }, {
    key: "setupEvents",
    value: function setupEvents() {
      var _this = this;
      $(document.body).on('wc_fragments_loaded wc_fragments_refreshed', this.resetFormElements.bind(this)).on('click', '#csygc-redeem-button', function (e) {
        e.preventDefault();
        _this.giftCardLookup();
      }).on('click', '#csygc-value-button', function (e) {
        e.preventDefault();
        _this.giftCardUse();
      }).on('click', 'a.csygc-gift-card-remove', function (e) {
        e.preventDefault();
        _this.giftCardRemove($(e.target));
      }).on('click', 'a.csygc-gift-card-edit', function (e) {
        e.preventDefault();
        _this.giftCardEditShow($(e.target));
      }).on('click', '.csygc-edit-save-button', function (e) {
        e.preventDefault();
        _this.giftCardEditTrigger($(e.target));
      }).on('click', '#gift_card_label_trigger', function (e) {
        _this.showGiftCardForm();
      }).on('click', '#csygc-recipient-gift', function (e) {
        _this.showHideRecipientFields();
      }).on('blur', '#csygc-value-gift-card-value', this.forceDecimals.bind(this));
    }
  }, {
    key: "giftCardLookup",
    value: function giftCardLookup() {
      var _this2 = this;
      var code = this.forms.cart.number.val(),
        security = this.forms.cart.security_code.val(),
        value_field = this.forms.cart.value;
      $('#csygc-redeem-error').html('').hide();
      this.block();
      console.log('Looking up gift card:', code, ' and Security:', security);
      $.ajax({
        url: CSYGC.ajaxurl,
        method: "POST",
        data: {
          action: 'csygc_check_card_value',
          code: code,
          security: security,
          _wpnonce: CSYGC.nonce.card_check
        },
        success: function success(response) {
          if (response.success) {
            $('#csygc-gift-card-value-container').show();
            value_field.attr({
              "max": response.data.card_value,
              "min": '0.01',
              "code": response.data.code,
              "secure": response.data.secure
            });
            value_field.data('max', response.data.card_value);
            value_field.val(response.data.card_value);
            _this2.forceDecimals();
          } else {
            _this2.addErrorMessage(response.data.message);
          }
        },
        complete: function complete() {
          return _this2.unblock();
        },
        error: function error(xhr, status, _error) {
          console.error(xhr.responseText);
          console.error(status);
          console.error(_error);
        }
      });
    }
  }, {
    key: "giftCardUse",
    value: function giftCardUse() {
      var _this3 = this;
      var value_field = this.forms.cart.value;
      if (!this.validateCardUse()) {
        return;
      }
      this.block();
      $.ajax({
        url: CSYGC.ajaxurl,
        method: "POST",
        data: {
          action: 'csygc_use_card_value',
          value: value_field.val(),
          code: value_field.attr('code'),
          security: value_field.attr('secure'),
          _wpnonce: CSYGC.nonce.value_submit
        },
        success: function success(response) {
          var notice = $('#gift_card_label_trigger.woocommerce-info');
          if (notice.length) {
            $('#csygc-card-inputs, #csygc-gift-card-value-container').hide();
          }
          jQuery(document.body).trigger('wc_update_cart').trigger('update_checkout');
        },
        complete: function complete() {
          return _this3.unblock();
        },
        error: function error(xhr, status, _error2) {
          console.error(xhr.responseText);
          console.error(err);
          console.error(status);
          console.error(_error2);
        }
      });
    }
  }, {
    key: "validateCardUse",
    value: function validateCardUse() {
      var value = parseFloat(this.forms.cart.value.val());
      var max = parseFloat(this.forms.cart.value.data('max'));
      if (isNaN(value) || isNaN(max)) {
        this.addErrorMessage(CSYGC.i18n.errors.invalid);
        return false;
      }
      if (value > max) {
        this.addErrorMessage(CSYGC.i18n.errors.large_value.replace('%s', CSYGC.currency_symbol + max));
        return false;
      }
      return true;
    }
  }, {
    key: "forceDecimals",
    value: function forceDecimals() {
      var value = parseFloat(this.forms.cart.value.val());
      if (isNaN(value)) {
        return;
      }
      this.forms.cart.value.val(value.toFixed(2));
    }
  }, {
    key: "addErrorMessage",
    value: function addErrorMessage(message) {
      $('#csygc-redeem-error').show().html('<p class="csygc_error_message woocommerce-error">' + message + '</p>');
    }
  }, {
    key: "giftCardRemove",
    value: function giftCardRemove(button) {
      var _this4 = this;
      var code = button.attr('data-card-number');
      this.block($('.cart_totals'));
      $.ajax({
        url: CSYGC.ajaxurl,
        method: "POST",
        data: {
          action: 'csygc_remove_card_value',
          code: code,
          _wpnonce: CSYGC.nonce.code_remove
        },
        success: function success(response) {
          $('.csygc-error-notice').remove();
          jQuery(document.body).trigger('wc_update_cart').trigger('update_checkout');
        },
        complete: function complete() {
          return _this4.unblock($('.cart_totals'));
        },
        error: function error(xhr, status, _error3) {
          console.error(xhr.responseText);
          console.error(status);
          console.error(_error3);
        }
      });
    }
  }, {
    key: "giftCardEditShow",
    value: function giftCardEditShow(button) {
      var form = button.parents('td').find('.csygc-edit-card-value');
      if (form.hasClass('open')) {
        form.removeClass('open').hide();
      } else {
        form.addClass('open').show();
      }
    }
  }, {
    key: "giftCardEditTrigger",
    value: function giftCardEditTrigger(button) {
      var _this5 = this;
      var code = button.closest("form").children('.csygc-value-gift-card-edit').attr('data-card-number'),
        value = button.closest("form").children('.csygc-value-gift-card-edit').val();
      this.block($('.cart_totals'));
      $.ajax({
        url: CSYGC.ajaxurl,
        method: "POST",
        data: {
          action: 'csygc_edit_card_value',
          code: code,
          value: value,
          _wpnonce: CSYGC.nonce.code_edit
        },
        success: function success(response) {
          jQuery(document.body).trigger('wc_update_cart').trigger('update_checkout');
        },
        complete: function complete() {
          return _this5.unblock($('.cart_totals'));
        },
        error: function error(xhr, status, _error4) {
          console.error(xhr.responseText);
          console.error(status);
          console.error(_error4);
        }
      });
    }
  }, {
    key: "showGiftCardForm",
    value: function showGiftCardForm() {
      var wrap = $("#csygc-card-inputs");
      if (!wrap.hasClass('open')) {
        wrap.addClass('open').slideDown({
          start: function start() {
            $(this).css({
              display: "flex"
            });
          }
        });
      } else {
        wrap.removeClass('open').slideUp();
      }
    }
  }, {
    key: "block",
    value: function block() {
      var ele = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var toBlock = this.forms.cart.form;
      if (ele) {
        toBlock = ele;
      }
      toBlock.block({
        message: null,
        overlayCSS: {
          background: '#fff',
          opacity: 0.6
        }
      });
    }
  }, {
    key: "unblock",
    value: function unblock() {
      var ele = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var toBlock = this.forms.cart.form;
      if (ele) {
        toBlock = ele;
      }
      toBlock.unblock();
    }
  }, {
    key: "showHideRecipientFields",
    value: function showHideRecipientFields() {
      var checked = this.forms.product.gift.is(':checked');
      if (checked) {
        this.forms.product.fields.show();
      } else {
        this.forms.product.fields.hide();
      }
    }
  }, {
    key: "setupEditMessageModal",
    value: function setupEditMessageModal() {
      var _this6 = this;
      var messages = _toConsumableArray(document.querySelectorAll('dd.variation-RecipientMessage'));
      var emails = _toConsumableArray(document.querySelectorAll('dd.variation-RecipientEmail'));
      var names = _toConsumableArray(document.querySelectorAll('dd.variation-RecipientName'));
      if (names.length > 0) {
        names.forEach(function (name) {
          var input = name.querySelector('.csygc-edit-name input[type="text"]');
          if (!input) {
            name.insertAdjacentHTML('beforeend', "<div class=\"csygc-edit-name\"><input type=\"text\" value=\"".concat(name.querySelector('p').innerText, "\" /></div>"));
          }
        });
      }
      if (emails.length > 0) {
        emails.forEach(function (email) {
          var input = email.querySelector('.csygc-edit-email input[type="text"]');
          if (!input) {
            email.insertAdjacentHTML('beforeend', "<div class=\"csygc-edit-email\"><input type=\"text\" value=\"".concat(email.querySelector('p').innerText, "\" /></div>"));
          }
        });
      }
      if (messages.length > 0) {
        messages.forEach(function (message) {
          var p = message.querySelector('p');
          var value = p.innerText;
          var saveText = CSYGC.edit_gift_message_save_text;
          var cartKey = $(message).parents('.cart_item').find('input[name="csygc_cart_item_key"]').val();
          var button = message.querySelector('.csygc-edit-message-button button');
          var textarea = message.querySelector('.csygc-edit-message textarea');
          var email = $(message).siblings('dd.variation-RecipientEmail').get(0);
          var name = $(message).siblings('dd.variation-RecipientName').get(0);
          if (!button && !textarea) {
            message.insertAdjacentHTML('beforeend', "<div class=\"csygc-edit-message\"><textarea type=\"text\">".concat(value, "</textarea></div><div class=\"csygc-edit-message-button\" data-save=\"").concat(saveText, "\">").concat(CSYGC.edit_gift_message_button, "</div>"));
            button = message.querySelector('.csygc-edit-message-button button');
            textarea = message.querySelector('.csygc-edit-message textarea');
            var editText = button.innerText;
            button.addEventListener('click', function (e) {
              e.preventDefault();
              if (message.classList.contains('open')) {
                var emailValue = email.querySelector('input[type="text"]').value;
                var nameValue = name.querySelector('input[type="text"]').value;
                var messageValue = textarea.value;
                if ('' === emailValue || '' === messageValue) {
                  alert('You cannot enter an empty value');
                  return;
                }
                // do save
                _this6.saveGiftMessage({
                  email: email.querySelector('input[type="text"]'),
                  name: name.querySelector('input[type="text"]'),
                  message: textarea,
                  emailDisplay: email.querySelector('p'),
                  nameDisplay: name.querySelector('p'),
                  messageDisplay: p
                }, cartKey, function () {
                  p.innerText = messageValue;
                  email.querySelector('p').innerText = emailValue;
                  name.querySelector('p').innerText = nameValue;
                }, function () {
                  button.innerText = editText;
                  email.classList.remove('open');
                  name.classList.remove('open');
                  message.classList.remove('open');
                });
              } else {
                button.innerText = saveText;
                message.classList.add('open');
                email.classList.add('open');
                name.classList.add('open');
              }
            });
          }
        });
      }
    }
  }, {
    key: "saveGiftMessage",
    value: function saveGiftMessage(_ref, cartKey, callback, close) {
      var _this7 = this;
      var email = _ref.email,
        name = _ref.name,
        message = _ref.message,
        emailDisplay = _ref.emailDisplay,
        nameDisplay = _ref.nameDisplay,
        messageDisplay = _ref.messageDisplay;
      var wrapper = '';
      if (this.isCart) {
        wrapper = $('.woocommerce-cart-form');
      }
      if (this.isCheckout) {
        wrapper = $('#order_review');
      }
      this.block(wrapper);
      $.ajax({
        url: CSYGC.ajaxurl,
        method: "POST",
        data: {
          action: 'csygc_update_gift_message',
          key: cartKey,
          message: message.value,
          email: email.value,
          name: name.value,
          _wpnonce: CSYGC.nonce.code_edit
        },
        dataType: 'json',
        success: function success(response) {
          if (response.success) {
            callback();
            if (_this7.isCart) {
              $(document.body).trigger('wc_update_cart');
            }
            if (_this7.isCheckout) {
              close();
              _this7.unblock(wrapper);
              $(document.body).trigger('update_checkout');
            }
          } else {
            close();
            message.value = messageDisplay.innerText;
            email.value = emailDisplay.innerText;
            name.value = nameDisplay.innerText;
            alert(response.data.message);
          }
        },
        complete: function complete() {
          return _this7.unblock(wrapper);
        },
        error: function error() {
          return close();
        }
      });
    }
  }]);
}();
var frontend = new Frontend();

},{}]},{},[1]);
